import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import History from "../../components/history";
import styles from "./MovimientosSnapshot.module.css";
import { Table, Row, Col, Form, Button } from "react-bootstrap";
import { NumericFormat } from 'react-number-format';
import { useCookies } from "react-cookie";
import Notifications, { notify } from "react-notify-toast";
import axios from "axios";
import { Especializaciones } from "../../core/especializaciones";
import { format } from "../../core/number";

const MovimientosSnapshot = (props) => {
  const { embedded = false, year: propYear } = props;
  const [cookie] = useCookies(["kUserSession"]);
  const [loading, setLoading] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [year, setYear] = useState(propYear ?? new Date().getFullYear());
  const [preview, setPreview] = useState([]);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [periodOpen, setPeriodOpen] = useState(false);
  const [snapshotIds, setSnapshotIds] = useState([]);

  const history = [
    { name: "Inicio", path: "/" },
    { name: "Movimientos de hacienda", path: "/movimientos" },
  ];

  const prepareHeaders = () => {
    return {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        api_key: "k-randa",
        access_token: cookie.kUserSession.data.access_token,
      },
    };
  };

  const retrievePreview = () => {
    setLoadingPreview(true);
    const currentFarm = cookie.kUserSession.data["farm"];
    const url =
      "movimiento_snapshot/preview?id_estancia=" +
      currentFarm.id +
      "&anho=" + year;
    axios
      .get(process.env.REACT_APP_API_URL + url, prepareHeaders())
      .then((rs) => {
        if (rs.status === 200) {
          setPreview(rs.data);
        } else {
          setPreview([]);
        }
        setLoadingPreview(false);
      })
      .catch((err) => {
        console.error(err);
        setPreview([]);
        setLoadingPreview(false);
      });
  };

  const retrievePeriodo = () => {
    const currentFarm = cookie.kUserSession.data["farm"];
    const url = `periodos/${year}/${currentFarm.id}`;
    axios
      .get(process.env.REACT_APP_API_URL + url, prepareHeaders())
      .then((rs) => {
        if (rs.status === 200) {
          setPeriodOpen(rs.data?.estado === "ABIERTO");
        } else {
          setPeriodOpen(false);
        }
      })
      .catch(() => setPeriodOpen(false));
  };

  const retrieve = () => {
    setLoading(true);
    const currentFarm = cookie.kUserSession.data["farm"];
    const url =
      "movimiento_snapshot?id_estancia=" +
      currentFarm.id +
      "&anho=" + year;
    axios
      .get(process.env.REACT_APP_API_URL + url, prepareHeaders())
      .then((rs) => {
        if (rs.status === 200 && rs.data && rs.data.data) {
          setInventory(rs.data.data);
          setSnapshotIds(rs.data.data.map((i) => i.id));
          setPreview([]);
        } else {
          setInventory([]);
          setSnapshotIds([]);
          retrievePreview();
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setInventory([]);
        setSnapshotIds([]);
        setLoading(false);
        retrievePreview();
      });
  };

  useEffect(() => {
    retrieve();
    retrievePeriodo();
  }, []);

  useEffect(() => {
    if (propYear !== undefined) {
      setYear(propYear);
    }
  }, [propYear]);

  useEffect(() => {
    retrieve();
    retrievePeriodo();
  }, [year]);

  const handleChange = (idx, field, value) => {
    setPreview((prev) => {
      const data = [...prev];
      const item = { ...data[idx] };
      if (field === "pesoProm") {
        const total = parseFloat(value || 0) * (item.cantidad || 0);
        item.pesoTotal = total;
        item.peso_total = total;
      } else if (field === "pesoTotal") {
        const total = parseFloat(value || 0);
        item.pesoTotal = total;
        item.peso_total = total;
      }
      data[idx] = item;
      return data;
    });
  };

  const edit = () => {
    setPreview(
      inventory.map((i) => ({
        idCategoria: i.idCategoria ?? i.categoria?.idCategoria,
        nombre: i.nombre ?? i.categoria?.nombre,
        carimbo: i.carimbo,
        cantidad: i.cantidad,
        pesoTotal: i.pesoTotal ?? i.peso_total,
        tipoMovimiento: i.tipoMovimiento ?? i.tipo_movimiento,
        especialidad: i.especialidad ?? i.especializacion,
      }))
    );
    setInventory([]);
  };

  const cancelEdit = () => {
    setPreview([]);
    retrieve();
    setConfirmLoading(false);
  };

  const deleteSnapshot = () => {
    if (!snapshotIds.length) return;
    Promise.all(
      snapshotIds.map((id) =>
        axios.delete(
          process.env.REACT_APP_API_URL + `movimiento_snapshot/${id}`,
          prepareHeaders()
        )
      )
    )
      .then(() => {
        notify.show("Movimientos eliminados", "success");
        setInventory([]);
        setSnapshotIds([]);
        retrievePreview();
      })
      .catch((err) => {
        console.error(err);
        notify.show("Ocurrió un error al eliminar", "error");
      });
  };

  const confirmSnapshot = () => {
    setConfirmLoading(true);
    const currentFarm = cookie.kUserSession.data["farm"];
    const body = {
      anho: year,
      id_estancia: currentFarm.id,
      movimientos: preview.map((i) => ({
        anho: year,
        id_estancia: currentFarm.id,        
        cantidad: i.cantidad,
        tipo_movimiento: i.tipoMovimiento,
        carimbo: i.carimbo,
        peso_total: i.pesoTotal,
        especializacion: i.especialidad,
        id_categoria: i.idCategoria,
      }))
      
    };
    axios
      .post(
        process.env.REACT_APP_API_URL + "movimiento_snapshot",
        body,
        prepareHeaders()
      )
      .then(() => {
        setConfirmLoading(false);
        notify.show("Movimientos confirmados", "success");
        retrieve();
      })
      .catch((err) => {
        console.error(err);
        setConfirmLoading(false);
        notify.show("Ocurrió un error al confirmar", "error");
      });
  };

  const normalize = (i) => ({
    idCategoria: i.idCategoria ?? i.categoria?.idCategoria,
    nombre: i.nombre ?? i.categoria?.nombre,
    carimbo: i.carimbo,
    tipoMovimiento: i.tipoMovimiento ?? i.tipo_movimiento,
    especialidad: i.especialidad ?? i.especializacion,
    cantidad: i.cantidad,
    pesoTotal: i.pesoTotal ?? i.peso_total,
  });

  const renderMovementTables = (rows, tipo, editable) => {
    const data = rows.filter(
      (i) => (i.tipoMovimiento ?? i.tipo_movimiento) === tipo
    );
    if (data.length === 0) return <></>;

    const especialidades = Array.from(
      new Set(data.map((d) => normalize(d).especialidad))
    );
    especialidades.sort((a, b) =>
      Especializaciones[tipo][a].localeCompare(Especializaciones[tipo][b])
    );
    const total = data.reduce((acc, cur) => acc + (cur.cantidad || 0), 0);
    const totalPeso = data.reduce(
      (acc, cur) => acc + (cur.pesoTotal || cur.peso_total || 0),
      0
    );

    return (
      <>
        <Row>
          {especialidades.map((esp) => {
            const espData = data.filter(
              (d) => normalize(d).especialidad === esp
            );
            const espTotal = espData.reduce(
              (acc, cur) => acc + (cur.cantidad || 0),
              0
            );
            const espPesoTotal = espData.reduce(
              (acc, cur) => acc + (cur.pesoTotal || cur.peso_total || 0),
              0
            );
            return (
              <Col md={6} key={esp}>
                <h6>
                  <strong>{Especializaciones[tipo][esp]}</strong>
                </h6>
                <Table
                  bordered
                  hover
                  responsive
                  className="karanda-table karanda-input-small"
                >
                  <thead>
                    <tr>
                      <th>Categoría</th>
                      <th>Cantidad</th>
                      <th>Peso prom.</th>
                      <th>Peso total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {espData.map((i, idx) => {
                      const globalIdx = preview.indexOf(i);
                      const n = normalize(i);
                      return (
                        <tr key={idx}>
                          <td>{n.nombre + (n.carimbo ? ' CO' + n.carimbo : '')}</td>
                          <td>{(n.cantidad || 0).toLocaleString()}</td>
                          <td>
                            {editable ? (
                              <NumericFormat
                                className="karanda-input karanda-input-small"
                                style={{ textAlign: 'right' }}
                                value={n.pesoTotal / n.cantidad}
                                customInput={Form.Control}
                                thousandSeparator="."
                                decimalSeparator="," 
                                decimalScale={2}
                                allowNegative={false}
                                onValueChange={(v) =>
                                  handleChange(globalIdx, 'pesoProm', v.floatValue)
                                }
                              />
                            ) : (
                              <span>{format(n.pesoTotal / n.cantidad, 2)}</span>
                            )}
                          </td>
                          <td>
                            {editable ? (
                              <NumericFormat
                                className="karanda-input karanda-input-small"
                                style={{ textAlign: 'right' }}
                                value={n.pesoTotal}
                                customInput={Form.Control}
                                thousandSeparator="."
                                decimalSeparator="," 
                                decimalScale={2}
                                allowNegative={false}
                                onValueChange={(v) =>
                                  handleChange(globalIdx, 'pesoTotal', v.floatValue)
                                }
                              />
                            ) : (
                              <span>{format(n.pesoTotal, 2)}</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    <tr style={{ fontWeight: 'bold' }}>
                      <td>Total</td>
                      <td>{espTotal.toLocaleString()}</td>
                      <td>{format(espTotal > 0 ? espPesoTotal / espTotal : 0, 2)}</td>
                      <td>{format(espPesoTotal, 2)}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            );
          })}
        </Row>
        <p style={{ margin: 0 }}>
          <strong>Total: {total.toLocaleString()}</strong>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Peso total: {format(totalPeso, 2)} kg.</strong>
        </p>
      </>
    );
  };

  return (
    <>
      {!embedded && <Header history={props.history} />}
      <section className={styles.body}>
        {!embedded && (
          <Row>
            <Col>
              <History
                items={history}
                current={"Movimientos de inventario"}
                history={props.history}
              />
            </Col>
          </Row>
        )}
        <Row>
          {!embedded && (
            <Col md={2} xs={12}>
              <section className={styles.side}>
                <Form className={styles.searchForm}>
                  <Form.Group>
                    <Form.Label htmlFor="periodo" className={styles.label}>
                      Periodo
                    </Form.Label>
                    <Form.Control
                      id="periodo"
                      className="karanda-input"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                      type="number"
                    />
                  </Form.Group>
                </Form>
              </section>
            </Col>
          )}
          <Col>
            <section className={styles.content}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "2rem",
                }}
              >
                <h1 className={styles.title} style={{ marginBottom: 0 }}>
                  Movimientos de inventario periodo {year - 1}/{year}
                </h1>
                {snapshotIds.length > 0 && periodOpen && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={deleteSnapshot}
                  >
                    Eliminar
                  </Button>
                )}
              </div>
              {loading ? (
                <span>Cargando...</span>
              ) : inventory.length === 0 ? (
                loadingPreview ? (
                  <span>Cargando...</span>
                ) : preview.length > 0 ? (
                  <>
                    <Row>
                      <Col>
                        <h5><strong>Entradas</strong></h5>
                        {renderMovementTables(preview, "E", true)}
                      </Col>
                      <Col>
                        <h5><strong>Salidas</strong></h5>
                        {renderMovementTables(preview, "S", true)}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <h5><strong>Ajustes</strong></h5>
                        {renderMovementTables(preview, "R", true)}
                      </Col>
                    </Row>
                    <div style={{ textAlign: "right", marginTop: "15px" }}>
                      <Button
                        className="karanda-btn"
                        onClick={confirmSnapshot}
                        disabled={confirmLoading}
                      >
                        {confirmLoading ? (
                          <span>Cargando...</span>
                        ) : (
                          <span>Confirmar</span>
                        )}
                      </Button>
                      <Button
                        className="karanda-btn-outline"
                        onClick={cancelEdit}
                        disabled={confirmLoading}
                        style={{ marginLeft: "10px" }}
                      >
                        Cancelar
                      </Button>
                    </div>
                  </>
                ) : (
                  <span>No hay registros</span>
                )
                ) : (
                  <>
                    <Row>
                      <Col>
                        <h5><strong>Entradas</strong></h5>
                        {renderMovementTables(inventory, "E", false)}
                      </Col>
                      <Col>
                        <h5><strong>Salidas</strong></h5>
                        {renderMovementTables(inventory, "S", false)}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <h5><strong>Ajustes</strong></h5>
                        {renderMovementTables(inventory, "R", false)}
                      </Col>
                    </Row>
                    {periodOpen && (
                      <div style={{ textAlign: "right", marginTop: "15px" }}>
                        <Button className="karanda-btn" onClick={edit}>
                          Editar
                        </Button>
                      </div>
                    )}
                  </>
                )}
            </section>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default MovimientosSnapshot;
